import { render, staticRenderFns } from "./MspForsageFoldersItem.vue?vue&type=template&id=d1fa86fc"
import script from "./MspForsageFoldersItem.vue?vue&type=script&lang=js"
export * from "./MspForsageFoldersItem.vue?vue&type=script&lang=js"
import style0 from "./MspForsageFoldersItem.vue?vue&type=style&index=0&id=d1fa86fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports